import React, { useState } from 'react';

// ID Tooltip Component - Shows screen/section IDs on hover for easier issue reporting and feature requests
const IDTooltip = ({ id, children, className = "", tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  return (
    <div 
      className={`relative inline-block ${className}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      data-screen-id={id}
    >
      {children}
      
      {/* ID Badge - Shows next to section title */}
      <div className="absolute -top-1 -right-8 z-10">
        <div 
          className={`
            px-1.5 py-0.5 text-xs font-mono bg-gray-100 text-gray-600 
            rounded border border-gray-300 shadow-sm cursor-help
            transition-opacity duration-200
            ${showTooltip ? 'opacity-100' : 'opacity-0 hover:opacity-100'}
          `}
          title={tooltip || `Screen ID: ${id} - Use this ID when reporting issues or requesting features for this section`}
        >
          {id}
        </div>
      </div>
    </div>
  );
};

export default IDTooltip;